import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../data/mock";
import { useLang } from "../context/LanguageContext";

const About = () => {
  const { t, lang } = useLang();
  const body = t("about_page.body");
  const values = t("about_page.values");

  return (
    <main className="bg-white dark:bg-black transition-colors">
      <section className="bg-[#800000] py-16 md:py-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 pointer-events-none">
          <div className="absolute -top-20 -left-20 w-80 h-80 bg-[#14532d] rounded-full blur-3xl" />
          <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-white rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">{t("about_page.title")}</h1>
          <p className="text-white/90 text-lg">{t("about_page.subtitle")}</p>
          <div className="flex items-center justify-center gap-2 mt-5">
            <div className="h-1 w-12 bg-white rounded-full" />
            <div className="h-1 w-6 bg-[#14532d] rounded-full" />
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-12 items-center">
            <div className="rounded-lg overflow-hidden border-4 border-[#800000] shadow-xl">
              <img src={IMAGES.main} alt="Dojo" className="w-full h-full object-cover min-h-[320px]" />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white mb-6">{t("about_page.our_story")}</h2>
              <div className="space-y-5 text-slate-700 dark:text-slate-300 leading-relaxed text-base md:text-lg">
                {Array.isArray(body) ? body.map((p, i) => <p key={`${lang}-${i}`}>{p}</p>) : <p>{body}</p>}
              </div>
              <div className="mt-8">
                <Link to="/contact" className="inline-flex items-center gap-2 bg-[#800000] text-white hover:bg-[#5a0000] px-6 py-3 rounded-md font-semibold shadow-md hover:shadow-lg transition-all group">
                  {t("about_page.cta")}
                  <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-slate-50 dark:bg-zinc-950 py-16 md:py-20 transition-colors">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white text-center mb-12">{t("about_page.teach_title")}</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {(Array.isArray(values) ? values : []).map((v, idx) => {
              const color = idx === 1 ? "#14532d" : "#800000";
              return (
                <div key={`${lang}-${idx}`} className="bg-white dark:bg-zinc-900 rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow border border-slate-100 dark:border-zinc-800 relative overflow-hidden">
                  <div className="absolute top-0 left-0 right-0 h-1" style={{ backgroundColor: color }} />
                  <div className="w-12 h-12 rounded-full flex items-center justify-center font-serif text-xl mb-4 text-white" style={{ backgroundColor: color }}>
                    義
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">{v.title}</h3>
                  <p className="text-slate-600 dark:text-slate-300 leading-relaxed">{v.text}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
